"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.driftStyled = exports.driftTheme = void 0;
const styles_1 = require("@mui/material/styles");
const system_1 = require("@mui/system");
const MuiOutlineInputOverrides_1 = __importDefault(require("./MuiOutlineInputOverrides"));
const InputBaseOverrides_1 = __importDefault(require("../components/inputBase/InputBaseOverrides"));
const MuiInputLabelOverrides_1 = __importDefault(require("../components/inputLabel/MuiInputLabelOverrides"));
const Palette_1 = require("./Palette");
const MuiChipOverrides_1 = __importDefault(require("../components/chip/MuiChipOverrides"));
const SwitchOverrides_1 = __importDefault(require("../components/switch/SwitchOverrides"));
const MuiSvgIconOverrides_1 = __importDefault(require("../components/icon/MuiSvgIconOverrides"));
const ButtonOverrides_1 = __importDefault(require("../components/button/ButtonOverrides"));
const MuiFormLabelOverrides_1 = __importDefault(require("../components/formLabel/MuiFormLabelOverrides"));
const MuiFormGroupOverrides_1 = __importDefault(require("../components/formGroup/MuiFormGroupOverrides"));
const MuiFormHelperTextOverrides_1 = __importDefault(require("../components/formHelperText/MuiFormHelperTextOverrides"));
const MuiTableRowOverrides_1 = __importDefault(require("../components/tableRow/MuiTableRowOverrides"));
const MuiTableCellOverrides_1 = __importDefault(require("../components/tableCell/MuiTableCellOverrides"));
const MuiTablePaginationOverrides_1 = __importDefault(require("../components/tablePagination/MuiTablePaginationOverrides"));
const MuiTableContainerOverrides_1 = __importDefault(require("../components/tableContainer/MuiTableContainerOverrides"));
const MuiDialogContentOverrides_1 = __importDefault(require("../components/dialogContent/MuiDialogContentOverrides"));
const MuiDialogContentTextOverrides_1 = __importDefault(require("../components/dialogContentText/MuiDialogContentTextOverrides"));
const MuiDialogTitleOverrides_1 = __importDefault(require("../components/dialogTitle/MuiDialogTitleOverrides"));
const MuiDialogActionsOverrides_1 = __importDefault(require("../components/dialogActions/MuiDialogActionsOverrides"));
const MuiDialogOverrides_1 = __importDefault(require("../components/dialog/MuiDialogOverrides"));
const MuiMenuItemOverrides_1 = __importDefault(require("../components/menuItem/MuiMenuItemOverrides"));
const MuiMenuOverrides_1 = __importDefault(require("../components/menu/MuiMenuOverrides"));
const MuiSelectOverrides_1 = __importDefault(require("../components/select/MuiSelectOverrides"));
const MuiSnackbarOverrides_1 = __importDefault(require("../components/snackbar/MuiSnackbarOverrides"));
const MuiDataGridOverrides_1 = __importDefault(require("../components/datagrid/MuiDataGridOverrides"));
const ScopedCssBaselineOverrides_1 = __importDefault(require("../components/scopedCssBaseline/ScopedCssBaselineOverrides"));
const CssBaselineOverrides_1 = __importDefault(require("../components/cssBaseline/CssBaselineOverrides"));
const AutocompleteOverrides_1 = __importDefault(require("../components/autocomplete/AutocompleteOverrides"));
const MuiTooltipOverrides_1 = __importDefault(require("../components/tooltip/MuiTooltipOverrides"));
const muiDrawerOverride_1 = __importDefault(require("../components/drawer/muiDrawerOverride"));
const AccordionOverrides_1 = __importDefault(require("../components/accordion/AccordionOverrides"));
const AccordionSummaryOverrides_1 = __importDefault(require("../components/accordion/AccordionSummaryOverrides"));
const AccordionDetailsOverride_1 = __importDefault(require("../components/accordion/AccordionDetailsOverride"));
const CheckboxOverrides_1 = __importDefault(require("../components/checkbox/CheckboxOverrides"));
const MuiBadgeOverrides_1 = __importDefault(require("../components/badge/MuiBadgeOverrides"));
const TabsOverrides_1 = __importDefault(require("../components/tabs/TabsOverrides"));
const MuiStepperOverrides_1 = __importDefault(require("../components/stepper/MuiStepperOverrides"));
const SkeletonOverrides_1 = __importDefault(require("../components/skeleton/SkeletonOverrides"));
const DriftCardOverrides_1 = __importDefault(require("../components/card/DriftCardOverrides"));
const MuiAlertOverrides_1 = __importDefault(require("../components/alert/MuiAlertOverrides"));
exports.driftTheme = (0, styles_1.createTheme)({
    palette: {
        mode: 'light',
        primary: {
            main: Palette_1.blue[500],
            light: Palette_1.blue[300],
            dark: Palette_1.blue[700],
        },
        error: {
            main: Palette_1.red[500],
            light: Palette_1.red[300],
            dark: Palette_1.red[700],
        },
        warning: {
            main: Palette_1.yellow[500],
            light: Palette_1.yellow[300],
            dark: Palette_1.yellow[700],
            contrastText: '#FFFFFF',
        },
        success: {
            main: Palette_1.green[500],
            light: Palette_1.green[300],
            dark: Palette_1.green[700],
            contrastText: '#FFFFFF',
        },
        blue: Palette_1.blue,
        green: Palette_1.green,
        red: Palette_1.red,
        yellow: Palette_1.yellow,
        orange: Palette_1.orange,
        gray: Palette_1.gray,
        background: {
            default: '#FFFFFF',
        },
        common: {
            black: '#000000',
            white: '#FFFFFF',
        },
        text: {
            disabled: Palette_1.gray[500],
            primary: Palette_1.gray[800],
            secondary: Palette_1.gray[700],
        },
    },
    typography: (palette) => ({
        fontFamily: 'proxima-nova',
        fontSize: 16,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        allVariants: {
            fontFamily: 'proxima-nova',
            lineHeight: 1.5,
            fontWeight: 400,
            color: palette.gray[800],
        },
        h1: {
            fontSize: '3rem',
            lineHeight: 1.2,
            color: palette.gray[900],
        },
        h2: {
            fontSize: '2.25rem',
            lineHeight: 1.2,
            color: palette.gray[900],
        },
        h3: {
            fontSize: '1.5rem',
            lineHeight: 1.2,
            color: palette.gray[900],
        },
        subtitle1: {
            fontSize: '1.125rem',
            color: palette.gray[700],
        },
        body1: {
            fontSize: '1rem',
        },
        body2: {
            fontSize: '0.875rem',
        },
        button: {
            textTransform: 'none',
            fontSize: '0.875rem',
        },
        caption: {
            fontSize: '0.75rem',
            color: palette.gray[900],
        },
        subtitle2: {
            fontSize: '0.625rem',
        },
    }),
    shape: {
        borderRadius: 8,
    },
    shadows: [
        // Elevation #0
        'none',
        // Elevation #1
        '2px 2px 1px -1px #00000033, 0px 1px 1px 0px #00000024, 0px 1px 3px 0px #0000001F',
        // Elevation #2
        '0px 3px 1px -2px #00000033, 0px 2px 2px 0px #00000024, 0px 1px 5px 0px #0000001F',
        // Elevation #3
        '0px 3px 3px -2px #00000033, 0px 3px 4px 0px #00000024, 0px 1px 8px 0px #0000001F',
        // Elevation #4
        '0px 2px 4px -1px #00000033, 0px 4px 5px 0px #00000024, 0px 1px 10px 0px #0000001F',
        // Elevation #5
        '0px 3px 5px -1px #00000033, 0px 5px 8px 0px #00000024, 0px 1px 14px 0px #0000001F',
        // Elevation #6
        '0px 3px 5px -1px #00000033, 0px 6px 10px 0px #00000024, 0px 1px 18px 0px #0000001F',
        // Elevation #7
        '0px 4px 5px -2px #00000033, 0px 7px 10px 1px #00000024, 0px 2px 16px 1px #0000001F',
        // Elevation #8
        '0px 5px 5px -3px #00000033, 0px 8px 10px 1px #00000024, 0px 3px 14px 2px #0000001F',
        // Elevation #9
        '0px 5px 6px -3px #00000033, 0px 9px 12px 1px #00000024, 0px 3px 16px 2px #0000001F',
        // Elevation #10
        '0px 6px 6px -3px #00000033, 0px 10px 14px 1px #00000024, 0px 4px 18px 3px #0000001F',
        // Elevation #11
        '0px 6px 7px -4px #00000033, 0px 11px 15px 1px #00000024, 0px 4px 20px 3px #0000001F',
        // Elevation #12
        '0px 7px 8px -4px #00000033, 0px 12px 17px 2px #00000024, 0px 5px 22px 4px #0000001F',
        // Elevation #13 - 24
        ...Array(12).fill('none'),
    ],
    components: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, muiDrawerOverride_1.default), AutocompleteOverrides_1.default), MuiChipOverrides_1.default), MuiDialogOverrides_1.default), MuiDialogActionsOverrides_1.default), MuiDialogContentOverrides_1.default), MuiDialogContentTextOverrides_1.default), MuiDialogTitleOverrides_1.default), MuiFormGroupOverrides_1.default), MuiFormHelperTextOverrides_1.default), MuiFormLabelOverrides_1.default), InputBaseOverrides_1.default), MuiInputLabelOverrides_1.default), MuiOutlineInputOverrides_1.default), MuiSelectOverrides_1.default), MuiMenuItemOverrides_1.default), MuiMenuOverrides_1.default), MuiSnackbarOverrides_1.default), MuiSvgIconOverrides_1.default), MuiTableCellOverrides_1.default), MuiTableContainerOverrides_1.default), MuiTablePaginationOverrides_1.default), MuiTableRowOverrides_1.default), SwitchOverrides_1.default), ButtonOverrides_1.default), MuiDataGridOverrides_1.default), ScopedCssBaselineOverrides_1.default), CssBaselineOverrides_1.default), MuiTooltipOverrides_1.default), AccordionOverrides_1.default), AccordionSummaryOverrides_1.default), AccordionDetailsOverride_1.default), CheckboxOverrides_1.default), MuiBadgeOverrides_1.default), TabsOverrides_1.default), MuiStepperOverrides_1.default), SkeletonOverrides_1.default), DriftCardOverrides_1.default), MuiAlertOverrides_1.default),
});
exports.driftStyled = (0, system_1.createStyled)({ defaultTheme: exports.driftTheme });
//# sourceMappingURL=Theme.js.map